module.exports = __webpack_public_path__ + "static/media/arrow-down-grey.2cd095f9.svg";